var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sparkline',{attrs:{"fill":false,"gradient":_vm.gradient,"line-width":2,"padding":8,"smooth":10 || false,"value":_vm.data,"auto-draw":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }